import PropTypes from 'prop-types';

// material-ui
import { Box, Container, Grid, Rating, Typography } from '@mui/material';

// third party
import Slider from 'react-slick';

// project import
import Avatar from '../../Components/@extended/Avatar';
import MainCard from '../../Components/MainCard';

import imgfeature1 from '../../assets/landing/genai343.jpg';

const Item = ({ item }) => (
  <MainCard sx={{ mx: 2 }} contentSX={{ p: 3 }}>
    <Grid container spacing={1}>
      <Grid item>
        <Avatar src={item.image} alt="feature" />
      </Grid>
      <Grid item sm zeroMinWidth>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Typography variant="h5" sx={{ fontWeight: 600 }}>
              {item.title}
            </Typography>
            <Rating name="read-only" readOnly value={item.rating} size="small" precision={0.5} />
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body1" color="grey">
              {item.review}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="subtitle2">{item.client}</Typography>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  </MainCard>
);

Item.propTypes = {
  item: PropTypes.shape({
    image: PropTypes.string,
    title: PropTypes.string,
    review: PropTypes.string,
    rating: PropTypes.number,
    client: PropTypes.string
  })
};

// ==============================|| LANDING - TESTIMONIAL PAGE ||============================== //

const TestimonialBlock = () => {
  const settings = {
    autoplay: true,
    arrows: false,
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1
  };

  const items = [
    {
      image: imgfeature1,
      title: 'Increased productivity',
      review:
        'By using ikigai and its integration with Xero it has helped me reduce the amount of time to do manual processing.',
      rating: 5,
      client: 'Michelle K.'
    },
    {
      image: imgfeature1,
      title: 'Rapid priority identification',
      review:
        "The receivables and payables tabs of the analytics dashboard has been highly useful in helping determine which accounts we need to prioritise on.",
      rating: 5,
      client: 'Andela R.'
    },
    {
      image: imgfeature1,
      title: 'Very cool',
      review: 'The ikigai platform is such an indispensable tool for our firm. It has helped us increase productivity and enabled our accountants to focus on what they do best.',
      rating: 4,
      client: 'En K.'
    },
    {
      image: imgfeature1,
      title: 'Time saving',
      review:
        "By using Ikigai processes that was time consuming due to its manual process has been simplified to just a few clicks.",
      rating: 5,
      client: 'Marco S.'
    },
    {
      image: imgfeature1,
      title: 'Everything in one place',
      review:
        'Ikigai is a well thought out platform. It has simplified and automated a lot of the manual processes.' +
          'We cannot wait to see more of the integrations and features that will be released onto the platform.',
      rating: 5,
      client: 'Katrina C.'
    }
  ];
  return (
    <Box sx={{ overflowX: 'hidden' }}>
      <Container>
        <Grid container alignItems="center" justifyContent="center" spacing={2} sx={{ mt: { md: 15, xs: 2.5 }, mb: { md: 10, xs: 2.5 } }}>
          <Grid item xs={12}>
            <Grid container spacing={1} justifyContent="center" sx={{ mb: 4, textAlign: 'center' }}>
              <Grid item sm={10} md={6}>
                <Grid container spacing={1} justifyContent="center">
                  <Grid item xs={12}>
                    <Typography variant="subtitle1" color="primary">
                      Testament
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography variant="h2">Customers Voice</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography variant="body1">
                      Below are some reviews from users of Ikigai.
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid item lg={6} md={8} xs={10} sx={{ '& .slick-list': { overflow: 'visible' } }}>
            <Slider {...settings}>
              {items.map((item, index) => (
                <Item key={index} item={item} />
              ))}
            </Slider>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default TestimonialBlock;